import { useState } from 'react';

const useTaxRecipientForm = () => {
  const [taxRecipientForm, setTaxRecipientForm] = useState({
    type: 'receiver',
    reason_for_export: 'commercially-sold-goods',
  });

  const [taxRecipientFormOptional, setTaxRecipientFormOptional] = useState({
    shipper_tax_identifier: '',
    receiver_tax_identifier: '',
    third_party_tax_identifier: '',
    additional_remarks: '',
    comments: '',
  });

  return {
    taxRecipientForm,
    taxRecipientFormOptional,
    setTaxRecipientForm,
    setTaxRecipientFormOptional,
  };
};

export default useTaxRecipientForm;
